var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ToiletCom',{attrs:{"bedId":_vm.bedId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }